// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { secondaryNavigationStyles } from "@sc/Overrides/Widgets/Header/SecondaryNavigation";
import { layoutContainer } from "@sc/XDL/Utilities";
import { css } from "styled-components";

secondaryNavigationStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${({ isInShellEditing }: any) => (isInShellEditing ? "" : "height: 30px;")}
        padding: 4px 0;
        ${layoutContainer}
    `,
};
secondaryNavigationStyles.rightSide = {
    css: css`
        display: flex;
    `,
};
secondaryNavigationStyles.currencyWrapper = {
    css: css`
        & > div {
            &:empty {
                display: none;
            }
            padding-left: 32px;
        }
    `,
};
secondaryNavigationStyles.languageWrapper = {
    css: css`
        & > div {
            &:empty {
                display: none;
            }
            padding-left: 32px;
        }
    `,
};
